module.exports = __webpack_public_path__ + "img/s18-journey-activity-click.07d3acb7.svg";